export default (myData) => {
  return {
    event: 'error',
    type: myData.type,
    statusCode: myData.statusCode,
    code: myData.code,
    actionable: myData.actionable,
    actionType: myData.actionType,
    errorMsg: myData.errorMsg,
    errorExtraInfo: myData.errorExtraInfo,
    URLpath: myData.URLpath ? myData.URLpath : '',
  };
}; 